import ApplicationController from '../../../../javascript/controllers/application_controller'

/**
 * Collection Search Controller
 *
 * Manages the "All" radio button behavior in collection role filtering.
 * When selected, this option is disabled to exclude it from form data.
 * On deselection, the option is re-enabled.
 *
 * Tracks user filter selections as breadcrumbs for debugging context.
 */
export default class extends ApplicationController {
  connect() {
    this.toggleDisabled()
  }

  toggleDisabled() {
    const wasChecked = this.element.checked

    this.element.disabled = this.element.checked

    // Track user filter selection
    if (wasChecked) {
      this.addBreadcrumb('Filter', 'collection_role_filter_changed', {
        role: 'all',
        action: 'selected',
      })
    }
  }
}
